import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {FORM_CONTENT_WIDTH, FORM_SIDEBAR_WIDTH, HEADER_HEIGHT_DESKTOP} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {
  MOBILE_SCREENSIZE,
  TABLET_SCREENSIZE,
  USER_TABLET_SCREENSIZE,
} from '@/utils/styles/breakpoints'

import {FormContainer} from './FormContainer'

type FormLayoutProps = {
  content: ReactNode
  sidebar?: ReactNode
  isModal?: boolean
  contentWidth?: string
}

export const FormLayout: FC<React.PropsWithChildren<FormLayoutProps>> = ({
  content,
  sidebar,
  isModal = false,
  contentWidth = FORM_CONTENT_WIDTH,
}) => (
  <>
    <FormContainer>
      <div className={cn('wrapper', isModal && 'modal')}>
        <div className="form">{content}</div>
        {sidebar && <aside className="sidebar">{sidebar}</aside>}
      </div>
    </FormContainer>

    <style jsx>{`
      .wrapper {
        display: flex;
        justify-content: ${sidebar ? 'space-between' : 'center'};
        margin: ${theme.spacing[7]} auto ${theme.spacing[9]};
      }
      .form {
        width: 100%;
        max-width: ${contentWidth};
      }
      .sidebar {
        position: sticky;
        top: calc(${HEADER_HEIGHT_DESKTOP} + ${theme.spacing[4]});
        width: 100%;
        height: 100%;
        max-width: ${FORM_SIDEBAR_WIDTH};
        margin-bottom: ${theme.spacing[8]};
      }
      .modal {
        margin-bottom: 0;
      }
      .modal .sidebar {
        top: -${theme.spacing[7]};
        margin-bottom: 0;
      }
      @media ${TABLET_SCREENSIZE} {
        .sidebar {
          top: ${theme.spacing[4]};
        }
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .wrapper {
          flex-direction: column-reverse;
          margin-top: 0;
        }
        .form {
          max-width: 100%;
        }
        .sidebar {
          left: 0;
          right: 0;
          top: 0;
          max-width: inherit;
          height: inherit;
          margin-bottom: 0;
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .wrapper {
          margin-bottom: ${theme.spacing[6]};
        }
      }
    `}</style>
  </>
)
